var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMail40X40 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#F3FAFF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.489 16.5H9.512c-.653 0-1.178.525-1.178 1.178v11.644c0 .653.525 1.178 1.178 1.178H30.49c.653 0 1.178-.525 1.178-1.178V17.678c0-.653-.525-1.178-1.178-1.178Z",
  fill: "#A3D3FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m29.917 21.167-9.916 4.666-9.917-4.666v-10.5A1.17 1.17 0 0 1 11.251 9.5h17.5a1.17 1.17 0 0 1 1.166 1.167v10.5Z",
  fill: "#2D91FF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 13.117c.252 0 .475.16.554.399l1.78 5.339 1.78-5.34a.584.584 0 0 1 1.107.37l-.692 2.076h1.305a.583.583 0 0 1 0 1.166H24.14l-1.252 3.758a.584.584 0 0 1-1.108 0L20 15.545l-1.779 5.34a.584.584 0 0 1-1.107 0l-1.253-3.758h-1.694a.584.584 0 0 1 0-1.166h1.305l-.692-2.076a.584.584 0 0 1 1.108-.37l1.78 5.34 1.779-5.34.036-.085c.1-.19.298-.313.518-.313Z",
  fill: "#fff"
})));
export default SvgIcMail40X40;